import { render, staticRenderFns } from "./TrucksRoadSendInvoices.vue?vue&type=template&id=07308ea2&scoped=true"
import script from "./TrucksRoadSendInvoices.vue?vue&type=script&lang=js"
export * from "./TrucksRoadSendInvoices.vue?vue&type=script&lang=js"
import style0 from "./TrucksRoadSendInvoices.vue?vue&type=style&index=0&id=07308ea2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07308ea2",
  null
  
)

export default component.exports